import React, { Component } from "react";
import { getURLParameters } from "./../lib/utils";
import i18n from "i18next";
import "./Footer.css";

export default class Footer extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      isCommentary: this.props.isCommentary,
    };
    this.openNewWindow = this.openNewWindow.bind(this);
  }
  
  componentWillReceiveProps(nextProps:any){
    this.setState({isCommentary : nextProps.isCommentary})
  }

  openNewWindow = () => {
    var lang = getURLParameters("lang");
    var cc = getURLParameters("cc");
    window.open(
      "/bochkfxibs/disclaimer?lang=" + lang + "&cc=" + cc,
      "_blank",
      " left=50%, top=50%, width=1024, height=680, scrollbars=1"
    );
  };

  openRiskWindow = () => {
    var lang = getURLParameters("lang");
    var cc = getURLParameters("cc");
    window.open(
      "/bochkfxibs/riskDisclosure?lang=" + lang + "&cc=" + cc,
      "_blank",
      " left=50%, top=50%, width=1024, height=680, scrollbars=1"
    );
  };

  changeFontSize(fontSize: string) {
    this.setState({
      fontSize: fontSize,
    });
    this.props.setfontsize(this.fontSizeConvertor(fontSize));
  }

  fontSizeConvertor(fontSize: string) {
    if (fontSize === "Normal") {
      return "80%";
    } else if (fontSize === "Larger") {
      return "100%";
    } else if (fontSize === "Largest") {
      return "130%";
    } else {
      return "100%";
    }
  }

  render() {
    return (
      <div className="footer-container">
        <div className="footer">
          <div className="footer-left">{i18n.t("Common.Copyright")}</div>
          <div className="footer-right">
            {/* {this.state.isCommentary && ( */}
              <div onClick={this.openRiskWindow}>
                {i18n.t("Common.DisclaimerLink", "")}
              </div>
            {/* // )} */}
            <div onClick={this.openNewWindow}>
              {i18n.t("Common.Disclaimer.Title2")}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
